import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Icon} from 'antd-mobile';
const Style = {
  border: 'none',
  outline: 'none',
  background: 'none'
};
export default class LinkText extends Component {
  constructor (props) {
    super(props);
    this.state = {
      show: false
    }
  }
  click = () => {
    const {show} = this.state;
    if(!show) {
      this.props.onClick && this.props.onClick()
    }
  };
  UNSAFE_componentWillMount() {
    this.setState({
      show: !!this.props.show
    })
  }

  render() {
    const {show} = this.props;
  return (
    <button className={show ? 'active' : ''}
        onClick={this.click}
        style={{...Style}}
    >
      {this.props.children || 'text'}
      <Icon size="xxs"
          type={show?'up':'down'}
      />
    </button>
  )
 }
}
